import { Audio, Images, Tweens } from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser';
import Gator from '../game/Gator';
import Newspaper from '../game/Newspaper';
import gameData from '../gameData';
import LocalizationUIAssets from '../Localization-UIAssets';
import UIAssetKeys from '../UIAssetKeys';

export default class TitleScene extends Phaser.Scene
{
    static get KEY() { return 'TitleScene'; }

    create()
    {
		this.subject = null;

		this.play = null;
		this.paper = null;

		this.bg = null;

		this.title = null;
		this.mask = null;

		this.tail = null;
		this.torso = null;
		this.arm = null;

		gameData.gameOver = false,
		gameData.gamePaused = false,
		gameData.currentScene = "titleScene",
		gameData.wrongAnswers = [],
		gameData.currentLevel = 1,
		gameData.time = 60,
		gameData.score = 0;
		gameData.correctAnswers = 0;
		gameData.incorrectAnswers = 0;

		Audio.playOneShot("later_gator_jingle", this, .5, true);
		
		this.bg = Images.addImage(0, 0, UIAssetKeys._BackgroundTitle, this).setOrigin(0);
		this.play = Images.addImage(0, 0, UIAssetKeys._PlayButton, this).setOrigin(0)
		this.subject = Images.addImage(0, 0, UIAssetKeys._Subtitle, this).setOrigin(0)

		//this.gator = new ABCya.Gator(this.game, this, "left", 1);
		this.gator = new Gator(this, "left", 1);
		this.add.existing(this.gator);

		this.title = Images.addImage(0,0, LocalizationUIAssets._Title, this, Images.LOCALIZATION_ATLAS).setOrigin(0);
		this.tail = Images.addImage(0,0, UIAssetKeys._GatorTail, this).setOrigin(0);
		this.arm = Images.addImage(0,0, UIAssetKeys._GatorArmRight, this).setOrigin(0);
		this.mask = Images.addImage(0,0, LocalizationUIAssets._tailMask, this, Images.LOCALIZATION_ATLAS).setOrigin(0);

		this.arm.alpha = 0;
		this.tail.alpha = 0;
		this.gator.alpha = 0;
		this.mask.alpha = 0;
		this.subject.alpha = 0;
		this.play.alpha = 0;
		this.title.alpha = 0;

		this.title.setScale(1, .02);
		this.arm.scaleY = 0;

		this.title.setOrigin(.5, 0);
		this.arm.setOrigin(1, .1);
		this.tail.setOrigin(.9, .4);
		this.subject.setOrigin(.5, .5);
		this.play.setOrigin(.5, .5);

		this.title.setPosition(this.scale.width/2, 90);
		this.subject.setPosition(this.scale.width/2, this.scale.height/2);
		this.play.setPosition(this.scale.width/2, this.scale.height/2);
		this.arm.setPosition(this.scale.width/2 + 160, 220);
		this.tail.setPosition(this.scale.width/4 + 63, 312);
		this.mask.setPosition(113, 198);
    if(ABCyaLib.Environment.instance.locale === 'en-GB' || ABCyaLib.Environment.instance.locale === 'en-AU'){
      this.mask.setPosition(111, 198);
    }

		this.gator.setPosition(535, 300);

		Audio.playOneShot("title_slime", this);

		Tweens.addTween(this.title, 2500, {scaleY:{start:.4, to: 1}, delay: 500}, Phaser.Math.Easing.Back.Out);
		Tweens.addTween(this.title, 1500, {alpha:1});
		Tweens.addTween(this.title, 3000, {y: this.scale.height/4 - 75, delay: 200}, Phaser.Math.Easing.Quadratic.Out, ()=>{
			
			Audio.playOneShot("later_gator_vo", this, 1, false, 0, Audio.LOCALIZATION_AUDIO_SPRITE);

			this.arm.alpha = 1;
			this.tail.alpha = 1;
			this.gator.alpha = 1;
			this.mask.alpha = 1;

			this.tail.angle = -220;
			this.arm.angle = -5;
			this.tail.x = this.scale.width/4 + 43;

			Tweens.addTween(this.gator, 1000, {y:70}, Phaser.Math.Easing.Quadratic.Out, ()=>{this.gator.idle()});
			Tweens.addTween(this.arm, 500, {scaleY:1},  Phaser.Math.Easing.Quadratic.Out);
			Tweens.addTween(this.tail, 1000, {angle:0, x:this.scale.width/4 + 63, y:210},  Phaser.Math.Easing.Quadratic.Out);

			Tweens.addTween(this.arm, 2000, {angle:10, delay: 500, repeat: -1, yoyo: true}, Phaser.Math.Easing.None, true, 500);

			Tweens.addTween(this.subject, 1000, {alpha:1, y:this.scale.height - this.scale.height/6 - 20},  Phaser.Math.Easing.Quadratic.Out);
			Tweens.addTween(this.play, 1000, {alpha:1, y:this.scale.height - this.play.height/2 - 40},  Phaser.Math.Easing.Quadratic.Out, ()=>{
				this.play.setInteractive();
				this.play.on('pointerdown', ()=>{

					Audio.playOneShot("gator_pop", this);

					this.play.disableInteractive();

					Tweens.addTween(this.play, 500, {alpha: 0}, Phaser.Math.Easing.None, ()=>{
						this.title.destroy();
						this.mask.destroy();
						this.subject.destroy();
						this.arm.destroy();
						this.gator.destroy();
						this.tail.destroy();
						this.play.destroy();
					});

					this.paper = new Newspaper(this, "intro");
					this.add.existing(this.paper);
				})
			});
		});
    }

	moveOn() {
		//console.log("GOING TO PLAY SCENE");
		Audio.playOneShot("gator_pop", this);

		//game.tweens.removeAll();
		this.tweens.killAll();
		this.sound.stopAll();

		this.paper.destroy();

		//game.state.start("PlayScene");
		//this.scene.start(TutorialScene.key)
		this.scene.start('TutorialScene');
	};
}